import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleAdminLogin = async () => {
    setLoading(true);
    try {
      const user = await login('admin');
      toast.success(`Logged in as ${user.name}`);
      navigate('/admin/overview');
    } catch (error) {
      toast.error('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Shield className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl font-semibold text-[#1d1d1f] mb-2">Admin Access</h1>
        <p className="text-base text-[#86868b] mb-8">Platform administration portal</p>
        <Button
          onClick={handleAdminLogin}
          disabled={loading}
          className="w-full bg-[#1d1d1f] hover:bg-[#333] text-white rounded-xl h-12"
          data-testid="admin-login-btn"
        >
          {loading ? 'Logging in...' : 'Sign in as Admin'}
        </Button>
      </div>
    </div>
  );
};

export default AdminLogin;
